export default "__VITE_ASSET__Dmk9hDpE__"